
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '1.3.4',
  revision: '469f046',
  branch: 'master'
};
